module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "do-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: false,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window',
      }),
      expression: "{\n              arrow: false,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n            }"
    }],
    staticClass: "hide-title-th",
    attrs: {
      "content": _vm.tooltipForHideTitle
    }
  }, [_vm._v(_vm._s(_vm.i18n['hide_title']) + " "), _c('span', {
    staticClass: "icon-question3"
  })]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(reason) {
    return _c('tr', {
      key: reason.id
    }, [_c('td', [_vm._v(_vm._s(reason.name))]), _vm._v(" "), _c('td', {
      staticClass: "hide-title-td"
    }, [_c('div', {
      staticClass: "do-table-flex"
    }, [_c('AppToggle', {
      attrs: {
        "propOn": reason.default_private
      },
      on: {
        "changed": function($event) {
          return _vm.$emit('editAbsencePrivate', reason)
        }
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "do-bttn do-bttn--small",
      class: {
        'do-bttn--loading': _vm.theUpdatingReasonId === reason.id
      },
      on: {
        "click": function($event) {
          return _vm.$emit('toggleArchived', reason)
        }
      }
    }, [_vm._v(_vm._s(reason.archived ? _vm.i18n['dearchive'] : _vm.i18n['archive']) + "\n      ")])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-790d2854!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AbsenceReasons/AbsenceReasonsTable.vue
// module id = 1691
// module chunks = 1